<template>
  <div class="modal animated fadeIn" tabindex="-1" role="dialog" :class="{ 'is-active': active }">
    <div class="modal-background"></div>
    <div class="modal-card animated fadeInUp">
      <header class="modal-card-head">
        <span class="close close-modal" @click="Events.$emit('closeAlertModal')" aria-hidden="true" v-if="dismiss !== false">
          <i class="icon icon-close"></i>
        </span>
        <!-- <p class="modal-card-title"></p> -->
      </header>
      <section class="modal-card-body">
        <img src="/images/sad.png">
        <h3>{{ title }}</h3>
        <p>{{ body }}</p>
      </section>
      <footer class="modal-card-foot push-top-small">
        <button v-for="value in actions" type="button" class="button is-primary is-large" @click="Events.$emit('alertModalDone', value)">{{ value }}</button>
      </footer>
    </div>
  </div>
</template>


<script>
  export default {
    props: ['active', 'title', 'body', 'actions', 'dismiss'],
    data() {
      return {
        Events: window.Events
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  .modal-background {
    background: hsla(0,0%,100%,.3);
  }
  .modal-card {
    width: 400px;
    img {
      width: 60px;
      display: block;
      margin: 0 auto 26px;
    }
    h3 {
      font-size: 16px;
      text-transform: uppercase;
      font-weight: 600;
      margin: 0 0 20px;
      letter-spacing: 1px;
      text-align: center;
    }
    p {
      margin-bottom: 25px;
    }
  }

</style>



// WEBPACK FOOTER //
// alert-modal.vue?67dd4e74